import {
  RequestDetailsInfoContainter,
  RequestDetailsInput,
  RequestDetailInfoCommentsContainer,
  RequestDetailsDatesContainer,
  RequestDetailsInfoContainerStyle,
  RequestDetailsStatusContainers,
  RequestDetailsStatusValue,
  RequestDetailsInfoComment,
  RequestNumberOfWorkingDays,
  RequestDetailsRequiredDocumentsContainer,
  RequestDetailsStartEndDatesContainer,
  RequestDetailsRequiredDocumentsContainerMobile,
  RequestDetailsEmployeeCommentContainer,
  RequestDetailsEmployeeCommentContainerMobile,
} from './styles/RequestDetailsInfoContainer.styled';
import {
  RequestDetailsStatusContainer,
  RequestDetailsStatusTitle,
  RequestDetailsParagraph,
} from './styles/RequestDetailsShared.style';
import { formatDate } from 'src/utils/dateFns/formatDate';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { truncateString } from 'src/utils/truncateString';
import { StatusEnum } from 'src/utils/mappers/checkStatusCode';
import { Tooltip } from '@fluentui/react-components';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { useContext } from 'react';

interface RequestDetailsInfoContainerProps {
  creationDate: string;
  vacationType: string;
  vacationStatus: string;
  startDate: string;
  endDate: string;
  numWorkDays: number;
  requireDocuments: boolean;
  employeeComment: string;
}

export const RequestDetailsInfoContainer = ({
  employeeComment,
  endDate,
  numWorkDays,
  requireDocuments,
  startDate,
  creationDate,
  vacationStatus,
  vacationType,
}: RequestDetailsInfoContainerProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  const { year, day, month } = formatDate(new Date(creationDate));
  const {
    year: startYear,
    month: startMonth,
    day: startDay,
  } = formatDate(new Date(startDate));
  const {
    year: endYear,
    month: endMonth,
    day: endDay,
  } = formatDate(new Date(endDate));
  const RequiredDocumentsView = () => {
    return (
      <>
        <RequestDetailsStatusTitle>
          Requires Documents:
        </RequestDetailsStatusTitle>
        <RequestDetailsParagraph>
          {requireDocuments !== null ? requireDocuments : '--'}
        </RequestDetailsParagraph>
      </>
    );
  };
  const EmployeeCommentView = () => {
    return (
      <>
        <RequestDetailsStatusTitle>
          Employee Comments:
        </RequestDetailsStatusTitle>
        <RequestDetailsInfoComment>
          {employeeComment ?? 'No additional comments'}
        </RequestDetailsInfoComment>
      </>
    );
  };
  return (
    <RequestDetailsInfoContainerStyle>
      <RequestDetailsStatusContainers>
        <RequestDetailsStatusContainer>
          {isMobile ? (
            <>
              <RequestDetailsStatusTitle>
                Creation date:
              </RequestDetailsStatusTitle>
              <RequestDetailsInput>
                <RequestDetailsParagraph>
                  {creationDate ? `${day}/${month}/${year}` : '--'}
                </RequestDetailsParagraph>
              </RequestDetailsInput>
            </>
          ) : (
            <>
              <RequestDetailsStatusTitle>
                Creation date:
              </RequestDetailsStatusTitle>
              <RequestDetailsStatusValue>
                {creationDate ? `${day}/${month}/${year}` : '--'}
              </RequestDetailsStatusValue>
            </>
          )}
        </RequestDetailsStatusContainer>
        <RequestDetailsStatusContainer>
          {isMobile ? (
            <>
              <RequestDetailsStatusTitle>Start Date:</RequestDetailsStatusTitle>
              <RequestDetailsInput>
                <RequestDetailsParagraph>
                  {startDate ? `${startDay}/${startMonth}/${startYear}` : '--'}
                </RequestDetailsParagraph>
              </RequestDetailsInput>
            </>
          ) : (
            <>
              <RequestDetailsStatusTitle>
                Time off Type:
              </RequestDetailsStatusTitle>
              <Tooltip
                relationship="description"
                content={vacationType.replace('Time-off', 'Time Off')}
              >
                <RequestDetailsStatusValue>
                  {vacationType
                    ? truncateString(
                        vacationType.replace('Time-off', 'Time Off'),
                        17
                      )
                    : '--'}
                </RequestDetailsStatusValue>
              </Tooltip>
            </>
          )}
        </RequestDetailsStatusContainer>
        <RequestDetailsStatusContainer>
          {isMobile ? (
            <>
              <RequestDetailsStatusTitle>End Date:</RequestDetailsStatusTitle>
              <RequestDetailsInput>
                <RequestDetailsParagraph>
                  {endDate ? `${endDay}/${endMonth}/${endYear}` : '--'}
                </RequestDetailsParagraph>
              </RequestDetailsInput>
            </>
          ) : (
            <>
              <RequestDetailsStatusTitle>Status:</RequestDetailsStatusTitle>
              <RequestDetailsStatusValue>
                {vacationStatus === StatusEnum.NEW
                  ? StatusEnum.WAITING_FOR_APPROVAL
                  : vacationStatus}
              </RequestDetailsStatusValue>
            </>
          )}
        </RequestDetailsStatusContainer>
      </RequestDetailsStatusContainers>
      <RequestDetailsInfoContainter>
        <RequestDetailsStartEndDatesContainer>
          <RequestDetailsDatesContainer>
            <RequestDetailsStatusContainer>
              {!isMobile ? (
                <>
                  <RequestDetailsStatusTitle>
                    Start Date:
                  </RequestDetailsStatusTitle>
                  <RequestDetailsInput>
                    <RequestDetailsParagraph>
                      {startDate
                        ? `${startDay}/${startMonth}/${startYear}`
                        : '--'}
                    </RequestDetailsParagraph>
                  </RequestDetailsInput>
                </>
              ) : (
                <>
                  <RequestDetailsStatusTitle>
                    Time off Type:
                  </RequestDetailsStatusTitle>
                  <TooltipHost content={vacationType} closeDelay={500}>
                    <RequestDetailsStatusValue>
                      {vacationType ? truncateString(vacationType, 17) : '--'}
                    </RequestDetailsStatusValue>
                  </TooltipHost>
                </>
              )}
            </RequestDetailsStatusContainer>
            <RequestDetailsStatusContainer>
              {!isMobile ? (
                <>
                  <RequestDetailsStatusTitle>
                    End Date:
                  </RequestDetailsStatusTitle>
                  <RequestDetailsInput>
                    <RequestDetailsParagraph>
                      {endDate ? `${endDay}/${endMonth}/${endYear}` : '--'}
                    </RequestDetailsParagraph>
                  </RequestDetailsInput>
                </>
              ) : (
                <>
                  <RequestDetailsStatusTitle>Status:</RequestDetailsStatusTitle>
                  <RequestDetailsStatusValue>
                    {vacationStatus === StatusEnum.NEW
                      ? StatusEnum.WAITING_FOR_APPROVAL
                      : vacationStatus}
                  </RequestDetailsStatusValue>
                </>
              )}
            </RequestDetailsStatusContainer>
          </RequestDetailsDatesContainer>
          <RequestDetailsRequiredDocumentsContainer>
            <RequiredDocumentsView />
          </RequestDetailsRequiredDocumentsContainer>
        </RequestDetailsStartEndDatesContainer>
        <RequestDetailInfoCommentsContainer>
          <RequestNumberOfWorkingDays>
            <RequestDetailsStatusTitle>
              Number of Work Days:
            </RequestDetailsStatusTitle>
            <RequestDetailsParagraph>
              {numWorkDays ?? '--'}
            </RequestDetailsParagraph>
          </RequestNumberOfWorkingDays>
          <RequestDetailsRequiredDocumentsContainerMobile>
            <RequiredDocumentsView />
          </RequestDetailsRequiredDocumentsContainerMobile>
          <RequestDetailsEmployeeCommentContainer>
            <EmployeeCommentView />
          </RequestDetailsEmployeeCommentContainer>
        </RequestDetailInfoCommentsContainer>
      </RequestDetailsInfoContainter>
      <RequestDetailsEmployeeCommentContainerMobile>
        <EmployeeCommentView />
      </RequestDetailsEmployeeCommentContainerMobile>
    </RequestDetailsInfoContainerStyle>
  );
};
